import { render } from "./DashboardLastOrders.vue?vue&type=template&id=6b7ebe9a&scoped=true"
import script from "./DashboardLastOrders.vue?vue&type=script&lang=js"
export * from "./DashboardLastOrders.vue?vue&type=script&lang=js"

import "./DashboardLastOrders.vue?vue&type=style&index=0&id=6b7ebe9a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7ebe9a"]])

export default __exports__